import { ActionContext, ActionTree } from 'vuex'
import { mutationType } from './mutation-types'
import RoleState, {IRoleList, RolePermissionList} from './states'
import _ from 'lodash'
import { State } from '@/store/store'
import Service from '@/services/HttpRequestServiceWithToken'

const baseUrl = process.env.VUE_APP_API_URL + '/v1'

const actions: ActionTree<RoleState, State> = {

  async CreateNewRole(
    { commit, dispatch, state }: ActionContext<RoleState, State>,
    roleName: string,
  ) {
    try {
      await Service.postByLevel(
        baseUrl,
        'role',
        {
          role: roleName,
        },
        (res: any) => {
          return res
        },
      )
    } catch (error) {
      console.log(error)
      throw error
    }
  },
  async getRoleList(
    { commit, dispatch, state }: ActionContext<RoleState, State>,
    option: object,
  ): Promise<void> {
    try {
      await Service.getByLevel(
        baseUrl,
        'role',
        option,
        (res: IRoleList) => {
          commit(mutationType.GET_LISTS, res)
        },
      )
    } catch (error) {
      console.log(error)
      throw error
    }
  },

  async GetRolePermissionList(
    { commit, dispatch, state }: ActionContext<RoleState, State>,
    path: string,
  ): Promise<void> {
    try {
      await Service.getByLevel(
        `${process.env.VUE_APP_API_URL}/v1`,
        path,
        {},
        (res: RolePermissionList) => {
          commit(mutationType.GET_ROLE_PERMISSION, res)
        },
      )
    } catch (error) {
      console.log(error)
      throw error
    }
  },

}

export default actions
